// Project-owned SeedThree preset for a young stinging nettle (Urtica dioica).
// Keeping the preset beside the integration makes the production build
// reproducible without relying on uncommitted files inside the vendor submodule.
export const stingingNettle = {
  name: 'Young Stinging Nettle',
  latin: 'Urtica dioica',
  category: 'shrub',
  bark: 'stinging_nettle_stem_albedo.png',
  leaf: 'stinging_nettle_single_albedo.png',
  biome: 'temperate',
  tileWorldSize: 0.12,
  plantSink: 0.008,
  foliageType: 'singleLeaves',
  foliage: {
    mode: 'leaves',
    leavesPerBranch: 10,
    size: 0.22,
    sizeVar: 0.22,
    widthRatio: 0.68,
    taper: 0.27,
    startFrac: 0.16,
    downAngle: 56,
    downAngleV: 7,
    droop: 8,
    droopV: 5,
    bend: 0.06,
    whorlSize: 2,
    rotate: 90,
    rotateV: 3,
    quads: 1,
    alphaTest: 0.42,
    tint: 0xffffff,
    transmit: [0.24, 0.43, 0.14],
    flutterScale: 0.62,
    parentSprays: 0,
  },
  params: {
    trunks: 1,
    trunkSplayDeg: 0,
    firstForkHeight: 0.72,
    armLength: 0.16,
    armFalloff: 0.9,
    forkGenerations: 1,
    branchiness: 0,
    forkSpread: 0,
    forkTriChance: 0,
    curlUp: 0.08,
    armBend: 1.5,
    gnarliness: 1.2,
    continuationKink: 0,
    forkRadiusKeep: 0.84,
    trunkRadius: 0.0055,
    trunkFlare: 0.16,
    trunkSegRes: 7,
    branchRepel: 0,
    minRadius: 0.0026,
    radialSegs: 5,
    segCurveRes: 6,
    tileWorldSize: 0.12,
    // The authored stem fibres run vertically in texture V, matching the
    // dichotomous tube's default longitudinal UV direction.
    barkGrainU: false,
    windWeightScale: 0.2,
  },
} as const;
